const mapException = exception => ({
  order_number: exception.order_number,
  expires_at: exception.expires_at,
  notes: exception.notes,
  enabled_for_refunds: exception.enabled_for_refunds,
  enabled_for_exchanges: exception.enabled_for_exchanges,
  disable_return_fees: exception.disable_return_fees,
  disable_exchange_fees: exception.disable_exchange_fees,
  only_store_credit: exception.only_store_credit,
  only_gift_card: exception.only_gift_card,
  send_notification_on_creation: exception.send_notification_on_creation,
  refund_shipping_amount: exception.refund_shipping_amount,
  policy_rule_id: exception.policy_rule_id,
})

export const transformRequestCreateException = ({ storeId, exception }) => ({
  storeId,
  exception: mapException(exception),
})

export const transformRequestEditException = ({ storeId, exception }) => ({
  storeId,
  exception: {
    id: exception.id,
    ...mapException(exception),
  },
})
